/* global Swiper */

document.querySelectorAll( '.b-posts-slider' ).forEach( ( block ) => {

	if ( !block ) {

		return;

	}

	const slider = block.querySelector( '.swiper' );
	const nextButton = block.querySelector( '.swiper-button-next' );
	const prevButton = block.querySelector( '.swiper-button-prev' );
	const sliderSpeed = block.dataset.sliderSpeed;
	const sliderAutoplay = block.dataset.autoplaySpeed;
	const slidesPerView = block.dataset.slidesPerView;
	const slidesPerGroup = block.dataset.slidesInGroup;

	const breakpoints = {
		576: {
			slidesPerView: 2,
			slidesPerGroup: 2,
		},
		992: {
			slidesPerView: 3,
			slidesPerGroup: 3,
		},
		1200: {
			slidesPerView: slidesPerView,
			slidesPerGroup: slidesPerGroup,
		},
	}

	new Swiper( slider, {
		watchOverflow: true,
		slidesPerView: 1,
		slidesPerGroup: 1,
		spaceBetween: 24,
		speed: sliderSpeed,
		autoplay: sliderAutoplay ? { delay: Number( sliderAutoplay ) } : false,
		loop: false,
		pagination: {
			el: '.swiper-pagination',
			type: 'progressbar',
			clickable: true,
		},
		navigation: {
			nextEl: nextButton,
			prevEl: prevButton,
		},
		breakpoints

	} );

} );

